interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-worm-950">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-accent-primary to-accent-secondary animate-pulse-slow" />
        <h1 className="text-2xl font-bold gradient-text mb-2">WholeWorm</h1>
        <p className="text-white/50 text-sm">{message}</p>
      </div>
    </div>
  );
}
